import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DatePicker, Icon, message } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';
import { saveSearchParams } from '../../../actions/rankActions';
import format from '../../shared/format';

const { MonthPicker } = DatePicker;
const monthFormat = 'YYYY-MM';

class TeachingRank extends Component {
    state = {
        list: [],
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { year, month } = res;
            const maxDate = format('month', year, month);
            let monthDate = maxDate;
            if (month >= 6 && month < 12) {
                monthDate = format('month', year, 6);
            } else if (month >= 1 && month < 6) {
                monthDate = format('month', year - 1, 12);
            }
            this.setState({
                maxDate,
                monthDate: moment(monthDate),
            }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        const { maxDate, monthDate = null } = this.state;
        this.setState({ loading: true });
        const date = monthDate ? monthDate.format(monthFormat) : maxDate;

        $.sendRequest({
            method: 'POST',
            url: API_URL.home.queryPerformanceUserScoreByType,
            data: {
                date,
                limit: 10,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    meanValue: res.avg,
                    list: res.result.datas,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    getColumns = () => {
        const columns = [
            {
                title: '排名',
                dataIndex: 'rank',
                key: 'rank',
                width: 60,
            }, {
                title: '带教老师',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 140,
                render: (text, record) => `${record.userCompellation}[${record.employeeCode}]`
            }, {
                title: '总分',
                dataIndex: 'totalPoint',
                key: 'totalPoint',
                width: 90,
            }, {
                title: '主要业绩分',
                dataIndex: 'mainAchievementPoint',
                key: 'mainAchievementPoint',
                width: 95,
            }, {
                title: '减分',
                dataIndex: 'minusPoint',
                key: 'minusPoint',
                width: 90,
            },
        ];
        return columns;
    }

    getDataSource = () => {
        const { list } = this.state;
        const dataSource = list.map((item, index) => (
            {
                index: index + 1,
                ...item,
            }
        ));
        return dataSource;
    }

    handleDateChange = (date, dateString) => {
        this.setState({ monthDate: date }, () => {
            this.loadData();
        });
    }

    prevMonth = () => {
        const { monthDate } = this.state;
        const newMonthDate = moment(monthDate).subtract(6, 'M');
        if (newMonthDate.valueOf() < moment('2021-12').valueOf()) {
            message.warning('不能小于该月份！');
            return;
        }
        this.setState({ monthDate: newMonthDate }, () => {
            this.loadData();
        });
    }

    nextMonth = () => {
        const { monthDate, maxDate } = this.state;
        const newMonthDate = moment(monthDate).add(6, 'M');
        if (newMonthDate.valueOf() > moment(maxDate).valueOf()) {
            message.warning('不能大于该月份！');
            return;
        }
        this.setState({ monthDate: newMonthDate }, () => {
            this.loadData();
        });
    }

    disabledDate = (current) => {
        const { maxDate } = this.state;
        const value = moment(maxDate).valueOf();
        const minValue = moment('2021-12').valueOf();
        const month = current.month();
        return (
            current &&
            !(
                current.valueOf() >= minValue &&
                current.valueOf() <= value &&
                (month === 5 || month === 11)
            )
        );
    }

    goToRank = () => {
        const { maxDate = '', monthDate = null } = this.state;
        const performanceState = { params: {} };
        this.props.saveParams(performanceState);
        location.href = `/#/teachingRank/${monthDate ? monthDate.format(monthFormat) : maxDate}`;
    }

    render() {
        const { monthDate = null, meanValue = 0, loading } = this.state;
        return (
            <article className="performanceTable flexItem outer">
                <header className="modTitle">带教绩效排行</header>
                <content className="boby">
                    <header className="monthSelect1">
                        <Icon type="left-circle-o" style={{ color: '#5850C9' }} onClick={this.prevMonth} />
                        <MonthPicker allowClear={false} value={monthDate} format={monthFormat} onChange={this.handleDateChange} disabledDate={this.disabledDate} />
                        <Icon type="right-circle-o" style={{ color: '#5850C9' }} onClick={this.nextMonth} />
                        <strong style={{ position: 'absolute', right: 20, lineHeight: '28px' }}>均值：{meanValue}</strong>
                    </header>
                    <div className="tableWrap">
                        <TableC
                            bordered={false}
                            loading={loading}
                            columns={this.getColumns()}
                            data={this.getDataSource()}
                        />
                    </div>
                </content>
                <footer className="footer">
                    <a className="more" onClick={this.goToRank}>查看更多&gt;&gt;</a>
                </footer>
            </article>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    saveParams: (params) => dispatch(saveSearchParams(params))
});

export default connect(null, mapDispatchToProps)(TeachingRank);


// WEBPACK FOOTER //
// ./src/components/homePage/performanceRank/TeachingRank.js